import { useState } from "react";
import { useSeo } from "@/lib/seo";
import { api, errMsg } from "@/lib/api";
import { OrderCard } from "@/components/OrderCard";
import { TRACK } from "@/constants/testIds";

const input = "w-full px-4 py-3 rounded-full border border-[#E7E0D3] bg-white focus:outline-none focus:ring-2 focus:ring-[#E06D44]/40";

export default function TrackPage() {
  useSeo({ title: "Track Your Order | PetTok Shop", description: "Track your PetTok Shop order with your order number and email to see shipping and tracking updates.", path: "/track" });
  const [orderId, setOrderId] = useState("");
  const [email, setEmail] = useState("");
  const [order, setOrder] = useState(null);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setOrder(null);
    try {
      const { data } = await api.get("/orders/track", { params: { order_id: orderId, email } });
      setOrder(data);
    } catch (err) {
      setError(errMsg(err));
    }
  };

  return (
    <main data-testid={TRACK.page} className="pt-32 pb-10 max-w-xl mx-auto px-6 min-h-[60vh]">
      <h1 className="font-heading text-4xl font-extrabold tracking-tight">Track an order</h1>
      <p className="mt-3 text-stone-600">Enter the order number from your confirmation and the email you used at checkout.</p>
      <form onSubmit={submit} className="mt-8 space-y-3">
        <input data-testid={TRACK.orderInput} required value={orderId} onChange={(e) => setOrderId(e.target.value)} placeholder="Order number, e.g. PT-1A2B3C4D" className={input} />
        <input data-testid={TRACK.emailInput} required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className={input} />
        <button data-testid={TRACK.submit} className="w-full py-3.5 rounded-full bg-[#1C1917] text-white hover:bg-[#E06D44] transition-colors">Find my order</button>
      </form>
      {error && <p data-testid={TRACK.error} className="mt-6 text-[#E11D48]">{error}</p>}
      {order && <div data-testid={TRACK.result} className="mt-8"><OrderCard order={order} /></div>}
    </main>
  );
}
